import React , {useState , useEffect} from "react";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Redirect,
} from "react-router-dom";
import "./App.css";
import Admin from "./Pages/admin";
import Home from "./Pages/Home";
import Hero from "./Pages/Hero";
import Login from "./Pages/Login";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

 /* return (
    
    <div>
    <Navigation />
    <Header data={landingPageData.Header} />
    <Features data={landingPageData.Features} />
    <About data={landingPageData.About} />
    <Team data={landingPageData.Team} />
    <Contact data={landingPageData.Contact} />
    </div>
   
  );*/
  
  return(
   

  <Router>
    
    <Routes>
      <>
     
    <Route path="/" element={<Home/>}/>
   <Route path="/admin" element={<Admin/>}/>
   </>
    </Routes>
    </Router>
  );

};

export default App;
